export default __webpack_public_path__ + "static/media/shoping.ff5ff07c.svg";